import { useState } from "react"
import { useCalculator } from "../context/CalculatorContext"
import {
  Label,
  getLabelsForAssetType,
  validateImprovementForm,
} from "../utils/formHelpers"
import { translate } from "../translations/translations"

export const useImprovementForm = () => {
  const { shipments, improvements, setImprovements } = useCalculator()
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})

  const assetType = shipments.assetType
  const labels: Label[] = getLabelsForAssetType(assetType)

  const handleChange = (key: string, value: string) => {
    const numericValue = parseFloat(value)
    const updatedImprovements = {
      ...improvements.improvements,
      [key]: numericValue || 0,
    }

    setImprovements({ ...improvements, improvements: updatedImprovements })

    if (numericValue < 0 || numericValue > 100 || isNaN(numericValue)) {
      setFormErrors((prev) => ({
        ...prev,
        [key]: translate("value_between_0_and_100"),
      }))
    } else {
      setFormErrors({})
    }
  }

  const handleValidation = (): boolean => {
    const { errors, isValid } = validateImprovementForm(
      improvements.improvements,
      labels,
    )
    setFormErrors(errors)
    return isValid
  }

  return {
    labels,
    formErrors,
    handleChange,
    handleValidation,
  }
}
